import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { getCheckoutUrl } from '../utils/getCheckoutUrl';
import { trackAddToCart } from '../utils/metaPixel';
const MAIN_PRICE = 4.99;
const BUMP_PRICES: Record<string, number> = {
  ia: 2.99,
  mensajes: 2.99,
  clientes: 2.99
};
interface FinalCTAProps {
  addedBumps: Record<string, boolean>;
}
export function FinalCTA({
  addedBumps
}: FinalCTAProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const bumpTotal = Object.entries(addedBumps).reduce((sum, [id, added]) => sum + (added ? BUMP_PRICES[id] || 0 : 0), 0);
  const total = MAIN_PRICE + bumpTotal;
  return <section ref={ref} className="py-32 px-6 bg-dark-secondary relative overflow-hidden" data-id="element-23">
      {/* Background glow */}
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-24">
        <div className="w-96 h-96 bg-accent/5 rounded-full blur-3xl" data-id="element-25" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-27">
          <span className="text-text-secondary line-through text-xl md:text-2xl block mb-2" data-id="element-28">
            Antes: €49.99
          </span>
          <span className="text-text-primary text-lg md:text-xl block mb-4" data-id="element-29">
            Hoy:
          </span>
          <motion.span key={total} initial={{
          scale: 1.15
        }} animate={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20
        }} className="text-accent text-5xl md:text-7xl font-bold block" data-id="element-30">
            €{total.toFixed(2)}
          </motion.span>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-text-secondary mb-10 leading-relaxed" data-id="element-31">
          No estás comprando información…{' '}
          <span className="text-text-primary font-semibold" data-id="element-32">
            estás comprando claridad.
          </span>
        </motion.p>

        <motion.a href={getCheckoutUrl(addedBumps)} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-block px-12 py-6 bg-accent text-dark-bg font-bold text-xl rounded-lg hover:bg-accent/90 transition-all shadow-2xl shadow-accent/30" data-id="element-33">
          Quiero empezar ahora
        </motion.a>
      </div>
    </section>;
}